import { createApp, defineComponent, computed, h } from 'vue';
import installZoomUI from '@/plugins/zoom-ui';
import ShoppingBag from '@/components/shopping-bag/index.vue';
import { isCheckoutPage } from '@/components/shopping-bag/helper';
import { persistCartConstant } from '@/views/config/shopping-cart/persist/persist-cart';

/**
 * Mount shopping bag component to the header container
 * @param {Object} dependencies - Required dependencies
 * @param {Object} dependencies.store - Vuex store instance
 * @param {Object} dependencies.i18n - i18n instance
 */
export function mountShoppingBag({ store, i18n }) {
  // if feature toggle is off, return
  if (!persistCartConstant.enablePersistShoppingBag) {
    return;
  }

  // if v2 flag is off, return
  if (!persistCartConstant.isShowPersistentCartV2) {
    return;
  }

  // Check if the container exists in DOM
  const container = document.querySelector('.billing-shopping-bag__container');
  if (!container) {
    console.warn('[mountShoppingBag] Container .billing-shopping-bag__container not found');
    return;
  }

  // Create a wrapper component that provides reactive count from store
  const ShoppingBagWrapper = defineComponent({
    name: 'ShoppingBagWrapper',
    setup() {
      const cartCount = computed(() => {
        return store.getters?.getSelectedPlans?.length || 0;
      });

      // Handle shopping bag click event
      const handleShoppingBagClick = () => {
        // Checkout page: trigger plan edit action
        if (isCheckoutPage()) {
          window.$context?.$emit('plan-edit-action');
          return;
        }
      };

      return () => h(ShoppingBag, {
        count: cartCount.value,
        onClick: handleShoppingBagClick,
      });
    },
  });

  // Create a new Vue app instance for the shopping bag
  const shoppingBagApp = createApp(ShoppingBagWrapper);

  // Share the same store instance
  shoppingBagApp.use(store);
  shoppingBagApp.use(i18n);
  installZoomUI(shoppingBagApp);

  // Mount the shopping bag app
  shoppingBagApp.mount(container);

  // Store reference for potential cleanup
  window.__shoppingBagApp__ = shoppingBagApp;
  console.log('[mountShoppingBag] Shopping bag mounted successfully');
}

